import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { AdminRoute, OperatorRoute, AuthRoute } from "./components/ProtectedRoute";
import PlayerHome from "./pages/PlayerHome";
import PlayerBook from "./pages/PlayerBook";
import PlayerConfirm from "./pages/PlayerConfirm";
import BookingStatus from "./pages/BookingStatus";
import OpenPlayRSVP from "./pages/OpenPlayRSVP";
import CoachingBooking from "./pages/CoachingBooking";
import LoginPage from "./pages/LoginPage";
import OperatorToday from "./pages/OperatorToday";
import OperatorDashboard from "./pages/OperatorDashboard";
import OperatorSettings from "./pages/OperatorSettings";
import RecurringBlocks from "./pages/RecurringBlocks";
import RecurringBookings from "./pages/RecurringBookings";
import AdminDashboard from "./pages/AdminDashboard";
import AccessRestricted from "./pages/AccessRestricted";
import ManageUsers from "./pages/ManageUsers";
import SetPassword from "./pages/SetPassword";
import ApproveBooking from "./pages/ApproveBooking";
import TournamentManager from "./pages/TournamentManager";
import FacebookAutoPost from "./pages/FacebookAutoPost";
import OperatorMembers from "./pages/OperatorMembers";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Player Routes (Public) */}
          <Route path="/" element={<PlayerHome />} />
          <Route path="/book" element={<PlayerBook />} />
          <Route path="/book/:bookingId" element={<BookingStatus />} />
          <Route path="/confirm" element={<PlayerConfirm />} />
          <Route path="/booking/:bookingId" element={<BookingStatus />} />
          <Route path="/open-play/:sessionId" element={<OpenPlayRSVP />} />
          <Route path="/coaching/:code" element={<CoachingBooking />} />
          <Route path="/approve-booking" element={<ApproveBooking />} />

          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invite/:token" element={<SetPassword />} />
          <Route path="/access-restricted" element={<AccessRestricted />} />

          {/* Operator Routes (Operator + Admin) */}
          <Route path="/operator" element={<AuthRoute><OperatorToday /></AuthRoute>} />
          <Route path="/today" element={<AuthRoute><OperatorToday /></AuthRoute>} />
          <Route path="/operator/dashboard" element={<OperatorRoute><OperatorDashboard /></OperatorRoute>} />

          {/* Admin-Only Routes */}
          <Route path="/operator/settings" element={<AdminRoute><OperatorSettings /></AdminRoute>} />
          <Route path="/operator/recurring" element={<AdminRoute><RecurringBlocks /></AdminRoute>} />
          <Route path="/operator/recurring-bookings" element={<OperatorRoute><RecurringBookings /></OperatorRoute>} />
          <Route path="/operator/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/operator/users" element={<AdminRoute><ManageUsers /></AdminRoute>} />
          <Route path="/operator/tournaments" element={<AdminRoute><TournamentManager /></AdminRoute>} />
          <Route path="/operator/facebook" element={<AdminRoute><FacebookAutoPost /></AdminRoute>} />
          <Route path="/operator/members" element={<AdminRoute><OperatorMembers /></AdminRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
